import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/services/store';
import LoadingSpinner from '@/components/LoadingSpinner';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />; // Or some other placeholder component
  }
  if (!isAuthenticated) {
    return <Navigate to="/auth/sign_in" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
